import observeStore from '../../store/observeStore';
import { slipRestore } from './actions';
import { getCurrentSlip } from './selectors';

const STORAGE_KEY = 'betting-buddy-slip';

export const persistSlipState = (state) => localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
export const getPersistedSlipState = () => JSON.parse(localStorage.getItem(STORAGE_KEY));

const syncCurrentSlipWithStorage = next => (reducer, initialState, enhancer) => {
  const store = next(reducer, initialState, enhancer);
  const slip = getPersistedSlipState();
  if (slip) {
    store.dispatch(slipRestore(slip));
  }
  observeStore(store, getCurrentSlip, state => persistSlipState(state.toJS()));

  return store;
};

export default syncCurrentSlipWithStorage;
